import { useEffect, useState } from "react";

const navLinks = [
  { label: "实时滚动", href: "#live" },
  { label: "热门榜单", href: "#hot" },
  { label: "主题分类", href: "#topics" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur-md"
          : "border-transparent bg-background-50/80 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center justify-between gap-6 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5" aria-label="黑料今日首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">黑料今日</span>
            <span className="hidden text-[11px] font-normal tracking-widest text-foreground-500 sm:block">实时滚动 · 热点追踪</span>
          </span>
        </a>

        <nav aria-label="站点主导航" className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer rounded-md px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <span className="hidden items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700 sm:flex">
            <span className="live-dot h-2 w-2 rounded-full bg-primary-500"></span>
            滚动更新中
          </span>
          <a
            href="#subscribe"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:block"
          >
            订阅热点
          </a>
          <button
            type="button"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav aria-label="移动端导航" className="mx-auto flex w-full max-w-[1400px] flex-col px-4 py-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={handleNavClick}
                className="cursor-pointer rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={handleNavClick}
              className="mt-2 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅热点
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}